<template>
<!-- THIS WILL UTILISE A 'FULLSCREEN' DIALOG (LOOK ON VUETIFY COMPONENT DOCS TO UNDERSTAND) -->
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn icon dark @click="dialogClosed()">
            <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{getLabel}} Profile</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
            <v-btn icon v-if="!myProfile" dark text @click="openChat()"><v-icon>mdi-chat</v-icon></v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card
        class="overflow-y-auto overflow-x-hidden"
        height="93vh"
        >
            <v-container fluid>
                <v-row dense>
                    <v-row>
                        <v-col cols="12" md="6" align-self="center">
                            <v-card
                                class="mx-2"
                                max-width="800"
                                color="grey lighten-2"
                                tile>
                                    <v-row wrap class="center text-center">
                                        <v-col cols="12" md="6" justify="space-around">
                                            <premium-badge :premiumInfo="localUser.premium"/>
                                            <v-avatar
                                            class="profile"
                                            size="164">
                                                <v-img
                                                :src="localUser.photo"
                                                lazy-src="https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
                                                aspect-ratio="1"
                                                class="grey lighten-2"
                                                max-height="150"
                                                max-width="150"
                                                :key="componentKey"
                                                ></v-img>
                                            </v-avatar>

                                            <v-btn v-if="myProfile" @click="showImageFileInput=!showImageFileInput">Update Profile Image</v-btn>
                                            <v-file-input
                                            v-if="showImageFileInput"
                                            accept="image/png, image/jpeg, image/bmp"
                                            show-size
                                            counter
                                            prepend-icon="mdi-camera"
                                            label="Upload Profile Image..."
                                            :value="newProfileImage"
                                            @change="updateProfileImage"
                                            ></v-file-input>

                                            <v-card-title class="primary--text justify-center"> {{localUser.displayname}} </v-card-title>
                                            <v-card-text v-if="myProfile">
                                                <v-tooltip bottom>
                                                    <template #activator="{ on }"> 
                                                        <v-icon v-on="on">mdi-account-circle</v-icon> {{localUser.firstname}} {{localUser.surname}}
                                                    </template>
                                                    <span>Full Name</span>
                                                </v-tooltip>
                                            </v-card-text>
                                        </v-col>
                                        <v-col cols="12" md="6" align-self="center">
                                            <v-row>
                                                <v-card-text v-if="myProfile">
                                                    <v-tooltip bottom>
                                                        <template #activator="{ on }">
                                                            <v-icon v-on="on">mdi-email</v-icon> {{localUser.email}}
                                                        </template>
                                                        <span>Email</span>
                                                    </v-tooltip> 
                                                </v-card-text>
                                            </v-row>
                                            <v-row>
                                                <v-card-text>
                                                    <v-tooltip bottom>
                                                        <template #activator="{ on }">
                                                            <v-icon v-on="on">mdi-map-marker</v-icon>City, United Kingdom
                                                        </template>
                                                        <span>Location</span>
                                                    </v-tooltip>
                                                </v-card-text>
                                            </v-row>
                                            <v-row>
                                                <v-card-text>
                                                    <v-tooltip bottom>
                                                        <template #activator="{ on }">
                                                            <v-icon v-on="on">mdi-heart</v-icon>{{getUserInterests}}
                                                        </template>
                                                        <span>Interests</span>
                                                    </v-tooltip>
                                                </v-card-text>
                                            </v-row>
                                            <v-row>
                                                <v-card-text>
                                                    <v-tooltip bottom>
                                                        <template #activator="{ on }">
                                                            <v-icon v-on="on">mdi-account-clock</v-icon>{{getLastOnline}}
                                                        </template>
                                                        <span>Last Online</span>
                                                    </v-tooltip>
                                                </v-card-text>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                            <activity-tracker :userDb="getLocalUser"></activity-tracker>
                        </v-col>
                    </v-row>

                        <v-col cols="12" md="6">
                            <div v-if="myProfile">
                                <a v-if="!editingInterests" color="primary" class="ma-2" @click="editingInterests=true">Change Interests</a>
                                <v-card v-if="editingInterests" class="ma-2">
                                    <v-row align="center" class="pa-2" wrap>
                                        <v-col cols="12" md="6">
                                            <category-control
                                            :parentSelectMode="false"
                                            @valueChanged="categoryChanged($event)"></category-control>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-btn class="ma-2" color="primary" @click="updateInterests()">Update Interests</v-btn>
                                            <v-btn class="ma-2" @click="editingInterests=false">Cancel</v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card>
                            </div>
                        </v-col>
                        
                        <v-col cols="12" md="6">
                            <div v-if="myProfile">
                                <a v-if="!editingPassword" color="primary" class="ma-2" @click="editingPassword=true">Change Password</a>
                                <v-card v-if="editingPassword" class="ma-2">
                                    <v-row align="center" class="pa-2" wrap>
                                        <v-row>
                                            <v-col cols="12" md="3" class="ma-2">
                                                <v-text-field
                                                label="Old Password"
                                                filled
                                                rounded
                                                dense
                                                :append-icon="password.oldPass.show ? 'mdi-eye' : 'mdi-eye-off'"
                                                :type="password.oldPass.show ? 'text' : 'password'"
                                                v-model="password.oldPass.value"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4" class="ma-2">
                                                <v-text-field
                                                label="New Password"
                                                filled
                                                rounded
                                                dense
                                                hint="At least 8 characters"
                                                counter
                                                :append-icon="password.newPass.show ? 'mdi-eye' : 'mdi-eye-off'"
                                                :type="password.newPass.show ? 'text' : 'password'"
                                                v-model="password.newPass.value"
                                                ></v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="4" class="ma-2">
                                                <v-text-field
                                                label="Confirm New Password"
                                                filled
                                                rounded
                                                dense
                                                hint="At least 8 characters"
                                                counter
                                                :append-icon="password.cNewPass.show ? 'mdi-eye' : 'mdi-eye-off'"
                                                :type="password.cNewPass.show ? 'text' : 'password'"
                                                v-model="password.cNewPass.value"
                                                ></v-text-field>
                                            </v-col>
                                        </v-row>

                                        <v-row>
                                            <v-col cols="12" md="12">
                                                <v-btn class="ma-2" color="primary" @click="updatePassword()">Update Password</v-btn>
                                                <v-btn class="ma-2" @click="editingPassword=false">Cancel</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-row>
                                </v-card>
                            </div>
                        </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" md="12">
                        <v-card height="100%" class="ma-2">
                            <v-card-title color="primary">Profile Stats</v-card-title>
                            <v-row wrap>
                                <v-col cols="12" md="6">
                                    <v-row wrap>
                                        <v-col cols="12" md="6">
                                            <v-card-title color="primary">Total Treatments: {{userStats.totalTreatments}} </v-card-title>
                                        </v-col>
                                        <v-col cols="12" md="6">
                                            <v-card-title color="primary">Total Upvotes: {{userStats.totalUpvotes}} </v-card-title>
                                        </v-col>
                                    </v-row>
                                    <v-row wrap>
                                        <v-container class="ma-0" fluid>
                                            <v-toolbar
                                                color="primary"
                                                dark
                                            >
                                                <v-toolbar-title>{{localUser.displayname}} Top Treatment's</v-toolbar-title>

                                                <v-spacer></v-spacer>

                                            </v-toolbar>

                                            <v-card xs12 style="overflow:auto" max-height="350px">
                                                <TreatmentListLite
                                                sort="Most Popular"
                                                :isPublic="true"
                                                :pageSize="3"
                                                :categories=[]
                                                :uid="this.$route.params.userDb.uid"
                                                currentCollectionSelected="Personal"></TreatmentListLite>
                                            </v-card>
                                        </v-container>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-card-title color="primary">Specialties: </v-card-title>
                                    <pie-chart ref='categoryChart' :data="categoryData" :options="categoryChartOptions"/>
                                </v-col>
                            </v-row>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>

        <v-dialog v-model="chatDialog" :retain-focus="false" fullscreen class="overflow-x-hidden" hide-overlay transition="slide-x-transition">              
            <chat-dialog
            v-if="chatDialog"
            v-on:dialogClosed="closeChatDialog()"
            :chatId="currentChat.id"
            :userIds="currentChat.userIds"
            :userId="this.$route.params.userDb.uid">
            </chat-dialog>
        </v-dialog>
    </v-card>
</template>

<script>
import PieChart from './../Charts/PieChart.vue'
import TreatmentListLite from './../Treatments/TreatmentList/TreatmentListLite.vue'
import CategoryControl from './../Treatments/Category/CategoryControl.vue'
import ActivityTracker from './ActivityTracker/ActivityTracker.vue';
import ChatDialog from './../Chat/ChatDialog.vue'
import PremiumBadge from './../Management/PremiumEligibilityBadge.vue';
import firebase from 'firebase';
import fb from '@/fb'; 
import UserRules from './config/userRules';
import UserDataService from './../../services/userDataService.js';
import TreatmentDataService from './../../services/treatmentDataService.js';
import ChatDataService from './../../services/chatDataService.js';
import swal from 'sweetalert2';
import Toast from './../../plugins/customToast.js';

export default {
    name: 'profileScreen',
    components: {
        PieChart,
        TreatmentListLite,
        ActivityTracker,
        CategoryControl,
        ChatDialog,
        PremiumBadge
    },
    props: {
        user: Object,
        label: String,
        myProfile: Boolean
    },
    mounted() {
        this.userDataService = new UserDataService();
        this.treatmentDataService = new TreatmentDataService();
        this.chatDataService = new ChatDataService();
        //We could place a watcher on this to keep an eye out for when any changes on the initial treatment occur?
        if (this.user){
            this.localUser = this.user;
            //Load method, that includes getting the users treatments
            this.load();
        }
    },
    methods: {     
        load(){
            this.loading = true;

            //NEED TO LEAVE THIS IN FOR THE TIME BEING. As stats are taken from the treatment items --> This could eventually be put into a cloud function.
            //May need to refactor this into a method within the treatmentDataService
            var that = this;
            fb.db.collection('treatments').where("owner", "==", this.localUser.uid)
            .onSnapshot(res => {
                const changes = res.docChanges();

                changes.forEach(change => {
                    if (change.type === 'added'){
                        that.treatmentItems.push({id: change.doc.id, data: change.doc.data()});
                    }
                })
                that.loading = false;
                that.loadStats();
            })
        },
        loadStats(){
            this.resetUserStats();
            this.populateUserStats();
        }, 
        populateUserStats(){
            var that = this;
            this.userStats.totalTreatments = this.treatmentItems.length;
            //Loop through all of these treatments
            this.treatmentItems.forEach(function (treatment){
                //Then loop through the current treatments categories
                treatment.data.category.forEach(function (category){
                    //(check if this treatment matches any existing categories)
                    if (that.userStats.categories.some(element => element.name === category))
                    {
                        //Find the index value now we know it exists:
                        const index = that.userStats.categories.findIndex(element => element.name === category);
                        //If they match, just increment this userStatCategories amount
                        that.userStats.categories[index].count++; 
                    } else {
                        //Otherwise, add this as a new user stat category
                        that.userStats.categories.push({name: category, count: 1});
                    }
                })
                that.userStats.totalUpvotes = that.userStats.totalUpvotes + treatment.data.upvotes;
            });

            this.populateCategoryData(this.userStats.categories);
        },
        resetUserStats(){
            this.userStats = {
                totalTreatments: 0,
                totalUpvotes: 0,
                categories: [{name: "Other", count: 0}]
            }
            this.resetCategoryData();
        },
        refreshLocalUser(){
            var that = this;
            this.userDataService.searchFirebaseByUserId(this.localUser.uid)
            .then(function (result) {
                if (result !== null){
                    //If call was successful for user, show their profile page
                    that.localUser = result;
                } else {
                    Toast.fire({  icon: 'error',  title: `Could not refresh user data`});
                }            
            }).catch(function (error) {
                Toast.fire({  icon: 'error',  title: `Could not refresh user data: ${error}!`});
            });       
        },
        populateCategoryData(categories){
            var that = this;
            this.resetCategoryData();
            categories.forEach(function (category){
                that.categoryData.labels.push(category.name);
                that.categoryData.datasets[0].data.push(category.count);
                that.categoryData.datasets[0].backgroundColor.push(that.random_rgba());
            })
            this.$refs.categoryChart.renderChart(that.categoryData, that.categoryChartOptions);
        },
        resetCategoryData(){
            this.categoryData = {
                labels: [],
                datasets: [
                    {
                    label: 'Categories',
                    backgroundColor: [
                    ],
                    data: []
                    }
                ]
            }
        },
        categoryChanged(categoriesSelected){
            this.currentSelectedInterests = categoriesSelected;
        },
        async updateInterests(){
            var that = this;
            var updateObject = {interests: this.currentSelectedInterests}
            this.userDataService.updateUserById(this.localUser.uid, updateObject)
            .then(function() {
                // Update successful.
                // show Swal/Success Message
                swal.fire({title: "Interests successfully changed", text: `You will now be returned to the dialog`, icon: "success", showConfirmButton: false, timer: 1500});
                that.refreshLocalUser()
                that.editingInterests = false;
            }).catch(function(error) {
                // An error happened.
                swal.fire({title: "Error occured when changing interests!", text: `Please contact your organisation administrator. Error: ${error}`, icon: "error", showConfirmButton: false});
            });   
        },
        async updatePassword(){
            //Confirm that they would like to change their password first
            // swal.fire({
            // title: 'Are you sure?',
            // text: "!",
            // icon: 'warning',
            // showCancelButton: true,
            // confirmButtonColor: 'lightgreen',
            // cancelButtonColor: 'red',
            // confirmButtonText: 'Yes, Change my password!'
            // }).then((result) => {
            //     if (result.value) {

            //     }
            // })
            var currentUser = firebase.auth().currentUser;

            //First Validate
            const valid = await this.validatePasswordUpdate(currentUser);

            if (valid !== true){
                //If invalid show Swal/Error Message
                swal.fire({title: "", text: `Solve the errors with your password first: ${valid.errorMessage}`, icon: "error", showConfirmButton: false});
            } else {
                //If it was valid update the password
                currentUser.updatePassword(this.password.cNewPass.value).then(function() {
                // Update successful.
                // show Swal/Success Message
                swal.fire({title: "Password successfully changed", text: `You will now be returned to the dialog`, icon: "success", showConfirmButton: false, timer: 1500});
                }).catch(function(error) {
                // An error happened.
                swal.fire({title: "Error occured when changing password!", text: `Please contact your organisation administrator. Error: ${error}`, icon: "error", showConfirmButton: false});
                });                
            }
        },
        async validatePasswordUpdate(currentUser){
            var that = this;

            //Validate the current password entry
            var errorList = [];
            var errorMessage = "";

            return new Promise(async function(resolve){
                //First Authenticate the user with the current password, if valid carry on, else return invalid with the error message
                var credential = firebase.auth.EmailAuthProvider.credential(
                firebase.auth().currentUser.email,
                that.password.oldPass.value
                );

                currentUser.reauthenticateWithCredential(credential).then(function() {
                // User successfully re-authenticated, carry on with validation as normal.

                    //Check that the new password isn't the same as the previous
                    if (that.password.oldPass.value === that.password.newPass.value){
                        errorList.push("Your new password must be different from your previous one");
                    }

                    //Then check if the two passwords match, if valid carry on, else return invalid with that error message
                    if (that.password.newPass.value !== that.password.cNewPass.value){
                        errorList.push("Your new passwords do not match when confirming!");
                    }

                    //Then check if it follows the rules set out
                    //Minimum Length
                    if (that.password.newPass.value.length < that.userRules.password.min)
                    {
                        errorList.push(`Your new password must be of minimum length ${that.userRules.password.min}`);
                    }
                    //Includes at least 1 special character
                    var characterExists = false;
                    for (var i = 0; i < that.password.newPass.value.length; i++){
                        var currentLetter = that.password.newPass.value[i];
                        if (that.userRules.password.specialCharacters.includes(currentLetter)){
                            //There is a special character, so break the loop and set bool to true
                            characterExists = true;
                            break;
                        }
                    }
                    if (!characterExists){
                        errorList.push(`Your new password must contain a special character`);
                    }

                    //Produce the error messages in here (push into a list, display a swal at the end)
                    if (errorList.length > 0){
                        for (var j = 0; j < errorList.length; j++){
                            if (j === 0){
                            errorMessage = "-" + errorList[j];              
                            } else {
                            errorMessage = errorMessage + ", \n-" + errorList[j];              
                            }
                        }

                    resolve({result: false, errorMessage: errorMessage});
                    } else {
                    resolve(true);
                    }  
                }).catch(function(error) {
                // An error happened.
                    resolve({result: false, errorMessage: "The Old Password you entered was incorrect, unable to reauthenticate user: " + error});
                });

                
            });
        },
        updateProfileImage(file){
            //First check if the object has something in, shouldn't open the dialog if it was just resetting the newProfileImage
            if (file) {
                //If they have chosen a new profile image to upload, prompt them with a confirm box (and show a preview?)
                //Swal event in here
                swal.fire({
                title: 'Are you sure you wish to update your profile image?',
                text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Confirm'
                }).then((result) => {
                    if (result.value) {
                        this.userDataService.uploadUserPhotoById(this.localUser.uid, file)
                        .then(() =>{
                            //Show Toast
                            Toast.fire({  icon: 'success',  title: `Successfully Updated Profile Photo`});
                            //Set the local photo to empty so that it updates/reloads:
                            this.localUser.photo = ""
                            //Then, revert the selected image and close the file input                            
                            this.newProfileImage = null,
                            this.showImageFileInput = false;
                            this.forceRerender(); //Reload the image components
                        }).catch((error) => {
                            //Show error toast, leave the fileInput field open
                            Toast.fire({  icon: 'error',  title: `Error Updating Profile Photo: ${error.message}`});
                        });
                    } else {
                        //If the user cancels, revert the selected image and close the file input
                        this.newProfileImage = null,
                        this.showImageFileInput = false;
                    }
                })
            }
        },
        dialogClosed(){
            this.resetUserStats();
            //Emit so that the parent call knows that the dialog has closed
            this.$emit("dialogClosed");
        },
        openChat(){
            //Just do a normal get/search for the chat (if it exists with the expected user id's and chat type --> then just open that current chat with the chatID just obtained)
            if (this.user.uid){
                const userIds = [this.localUser.uid, this.$route.params.userDb.uid];
                
                this.chatDataService.getExistingChat(userIds, "Private", null)
                .then(chatDoc => {
                    this.currentChat = {id: chatDoc.id, userIds: chatDoc.data.users};
                    this.chatDialog = true;
                })
                .catch(error => {
                    if (error === "No chat exists"){
                        //Then the chat doesn't exist but we need to create a new one
                        this.chatDataService.createNewChat(`${this.localUser.displayname}, ${this.$route.params.userDb.displayname}`, "Private", [this.localUser.uid, this.$route.params.userDb.uid], "")
                        .then((result) => {
                            //Once we have successfully created the chat we can then get the existing chat as normal (so that we can open and join it)
                            console.log(result); //eslint-disable-line

                            this.chatDataService.getExistingChat(userIds, "Private", null)
                            .then(chatDoc => {
                                this.currentChat = {id: chatDoc.id, userIds: chatDoc.data.users};
                                this.chatDialog = true;
                            })
                        })
                        .catch((error) => {
                            Toast.fire({  icon: 'error',  title: `Could not open chat: ${error}`});
                        })
                    } else {
                        //Otherwise, there was a real error report this back
                        Toast.fire({  icon: 'error',  title: `Could not open chat: ${error}`});
                    }
                })
            }
                
            //for organisations, if the chat does exist (using orgID) but the user can't be found --> Join the existing chat, retain the id and open the chat as normal
        },
        closeChatDialog(){
            this.chatDialog = false;
            this.currentChat = {};
        },
        random_rgba() {
            var o = Math.round, r = Math.random, s = 255;
            return 'rgba(' + o(r()*s) + ',' + o(r()*s) + ',' + o(r()*s) + ',' + r().toFixed(1) + ')';
        },
        forceRerender(){
            this.componentKey += 1;
        }
    },
    watch: {
        localUser: {
            immediate: false,
            deep: true,
            handler(val) {
                if (val.photo === ""){
                this.localUser.photo = this.user.photo
                }
            }
        }
    },
    computed: {
        getLabel(){
            var fullLabel = this.label;
            if (!this.myProfile)
            {
                fullLabel = this.label + "'s";
            }
            return fullLabel;
        },
        getUserInterests(){
            if (this.localUser.interests){
                return this.localUser.interests.join();
            }
            return ""
        },
        getLastOnline(){
            if (this.localUser.online){
                return this.localUser.online.status;
            } else {
                return " Hours ago"; //+ this.localUser.online.lastSeen;
            }
        },
        getLocalUser(){
            if (Object.keys(this.localUser).length !== 0){
                return this.localUser;
            } else {
                return {};
            }
        }
    },
    data: () => ({
        localUser: {},
        editingPassword: false,
        editingInterests: false,
        currentSelectedInterests: [],
        userRules: UserRules,
        password: {
            oldPass: {    
                value: "",
                show: false
            },
            newPass: {
                value: "",
                show: false
            },
            cNewPass: {
                value: "",
                show: false
            },
        },
        categoryChartOptions: {
            responsive: true,
            maintainAspectRatio: false
        },
        categoryData: {
            labels: [],
            datasets: [
                {
                label: 'Categories',
                backgroundColor: [
                ],
                data: []
                }
            ]
        },
        loading: false,
        treatmentItems: [],
        userStats: {
            totalTreatments: 0,
            totalUpvotes: 0,
            categories: [{name: "Other", count: 0}]
        },
        userDataService: {},
        treatmentDataService: {},
        chatDialog: false,
        currentChat: {},
        showImageFileInput: false,
        newProfileImage: null,
        componentKey: 0
    })    
}
</script>
